/**
 * Thumbnail upload / map-viewer utility shells.
 * Map marker footprint comes from mapChromeShell (pin / thumb / cluster).
 * Typography via typeShell; layout only here.
 */

import { mapChromeShell } from "./mapChromeShell";
import { typeShell } from "./typeShell";

const placeholderLayout =
    "flex h-full min-h-16 min-w-0 max-w-full flex-1 items-center justify-center overflow-hidden rounded-lg border border-solid border-border bg-surface-muted bp-md:min-h-20 bp-2xl:min-h-[7.5rem]";

const dropzoneLayout =
    "box-border h-full min-h-16 min-w-0 max-w-full flex-1 overflow-hidden px-2 py-1.5 bp-md:min-h-20 bp-md:py-2 bp-2xl:min-h-[7.5rem] bp-2xl:px-3 bp-2xl:py-3";

export const thumbnailShell = {
    /** Fill spare parent height; keep intrinsic min size so the editor section can scroll. */
    uploader: "m-0 flex min-h-0 w-full min-w-0 max-w-full grow shrink-0 flex-col gap-1 overflow-hidden p-0",

    label: `m-0 shrink-0 ${typeShell.fieldLabel}`,

    horizontalLayout:
        "flex min-h-0 w-full min-w-0 max-w-full grow flex-col gap-2 overflow-hidden bp-md:flex-row bp-md:items-stretch bp-md:gap-2 bp-2xl:gap-4",
    previewSection: "flex min-h-16 min-w-0 w-full max-w-full grow flex-col overflow-hidden bp-md:min-h-20 bp-2xl:min-h-[7.5rem]",
    uploadSection: "flex min-h-16 min-w-0 w-full max-w-full grow flex-col overflow-hidden bp-md:min-h-20 bp-2xl:min-h-[7.5rem]",

    previewWrapper:
        "relative mb-0 flex h-full min-h-16 min-w-0 max-w-full flex-1 items-center justify-center overflow-hidden rounded-md border-none bg-surface-muted p-1 bp-md:min-h-20 bp-md:p-1.5 bp-2xl:min-h-[7.5rem] bp-2xl:p-2",
    previewImage:
        "block h-full w-full rounded border-none object-cover",
    placeholder: `${placeholderLayout} ${typeShell.empty}`,

    /** Overrides formShell.dropzone padding for compact InfoWindow */
    dropzone: `${dropzoneLayout} ${typeShell.actionPrompt}`,
    dropzoneMessage: "m-0 text-inherit",

    removeButton:
        "!absolute !right-1 !top-1 z-10 !inline-flex !min-h-7 !min-w-10 !items-center !justify-center !rounded !border-none !bg-button-danger !px-2 !py-0.5 !text-xs !font-semibold !leading-tight !text-text-inverse !no-underline transition-all duration-200 hover:!bg-button-danger-hover hover:-translate-y-px bp-md:!min-h-6 bp-md:!px-1.5 bp-md:!py-1",

    /* Map marker viewer thumbnail (ThumbnailOnViewer) — same footprint as pin */
    viewer: mapChromeShell.thumbnailMarker,
    viewerImage: "thumbnail-image transition-transform duration-300 [image-orientation:from-image]",
};
